import React from 'react';
import Avatar from '@mui/material/Avatar';
import Skeleton from '../Skeleton';
import * as S from './styles';
const PrivateLoader = ({ skeletonColumns = 4 }) => {
    const columns = new Array(skeletonColumns).fill(null);
    return (React.createElement(S.CustomBox, { "aria-label": "loading", role: "presentation" },
        columns.map((_, index) => (React.createElement(Skeleton, { key: index, variant: "rounded", width: 110, height: 24 }))),
        React.createElement(Skeleton, { variant: "circular" },
            React.createElement(Avatar, null))));
};
export default PrivateLoader;
//# sourceMappingURL=PrivateLoader.js.map